import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAll = () => {
  return instance.get("/location", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/location/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/location", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/location/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/location/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/location`);
};

const findByTitle = (title) => {
  return instance.get(`/location?title=${title}`);
};

const ShopService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default ShopService;
